import Config from "../Service.js/config";
import authHeader from "../Service.js/authHeader";
import { message, Spin, Upload } from "antd";
import uploadIcon from "../Assets/Icons/uploadgroup.svg";
import { useState } from "react";
import JobService from "../Service.js/jobService";
import toast from "react-hot-toast";
import deleteIcon from "../Assets/Icons/deleteIcon.svg";
import resumeImage from "../Assets/Icons/groupresume.png";

import { Button as AntdButton, Button } from "antd";
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons";
const EmployeeRefer = (prop) => {
  const { Dragger } = Upload;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const contentStyle = {
    padding: 50,
    borderRadius: 4,
  };

  const content = <div style={contentStyle} />;
  const jobList = async () => {
    await JobService.jobList()
      .then((response) => {})
      .catch((err) => {});
  };

  const props = {
    name: "resume",
    accept: ".doc,.docx,.rtf,.pdf",
    multiple: true,

    beforeUpload: (file) => {
      // Prevent automatic upload
      setSelectedFiles((prevFiles) => [...prevFiles, file]);
      return false; // Prevent default upload action
    },
    // onChange(info) {
    //   const { status, originFileObj } = info.file;
    //   if (status === "done" || status === "error") {
    //     setSelectedFiles((prevFiles) => [...prevFiles, originFileObj]);
    //     //message.success(`${info.file.name} file selected successfully`);
    //   }
    // },
    onRemove(file) {
      setSelectedFiles((prevFiles) =>
        prevFiles.filter((f) => f.uid !== file.uid)
      );
    },
    onDrop(e) {
      const droppedFiles = Array.from(e.dataTransfer.files);
      setSelectedFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    },
  };
  const handleRemoveFile = (file) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((f) => f.uid !== file.uid)
    );
  };
  console.log("selectedFiles", selectedFiles);
  const fileListItems = selectedFiles.map((file) => (
    <div key={file.uid} className="rounded-lg border border-gray-300 p-2 mt-4">
      <div className="flex flex-wrap justify-between ">
        <div className="flex">
          <img src={resumeImage} alt="resumeImage" />
          <span className="pl-4 pt-4">{file.name}</span>
        </div>
        <img
          src={deleteIcon}
          alt="deleteIcon"
          onClick={() => handleRemoveFile(file)}
          className="cursor-pointer"
        />
        {/* <DeleteOutlined
          className="delete-icon"
          onClick={() => handleRemoveFile(file)}
        /> */}
      </div>
    </div>
  ));
  const handleResumes = async () => {
    console.log("listupload", selectedFiles.length);
    if (selectedFiles.length == 0) {
      toast.error("Please Upload file");
    } else {
      setLoading(true);
      await JobService.referCandidates(prop.jobId, selectedFiles)
        .then((response) => {
          if (response.data.success == true) {
            setLoading(false);
            toast.success("SucessFully Submitted");
            prop.setModalOpen(false);
            jobList();
            setSelectedFiles([]);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Failed ");
        });
    }
    console.log("file", selectedFiles);
  };
  return (
    <div className="w-full mb-8">
      {loading ? (
        <div className="flex flexwrap justify-center items-center pt-60 pb-60">
          <Spin tip="Uploading Please Wait" size="large">
            {content}
          </Spin>
        </div>
      ) : (
        <div>
          <p className="text-base font-semibold mt-12">
            You can upload multiple resume at a time
          </p>

          <div className="mt-8 mb-8">
            <Dragger
              {...props}
              showUploadList={false}

              //  defaultFileList
              //\.ant-upload-drag
            >
              <div className="mb-6 chart_div mx-auto mt-4 p-1 ">
                <div>
                  <img src={uploadIcon} alt="uploadIcon" />
                </div>
              </div>
              <p className="pt-2 text-base font-semibold">
                Upload or drag and drop resume file here
              </p>
              <p className="ant-upload-text pt-2 pb-8">
                Max, file size: 10MB (PDF, Doc, Png )
              </p>
            </Dragger>
          </div>
          <div className="file-list">{fileListItems}</div>
          <div className="pt-6 flex justify-center items-center">
            <button
              className="bg-[#1C4980] text-white h-[42px] rounded-full p-4 font-semibold"
              type="button"
              onClick={handleResumes}
            >
              Send Resume
            </button>{" "}
          </div>
        </div>
      )}
    </div>
  );
};
export default EmployeeRefer;
